export default {"src":"/_next/static/media/ne.3fd07a99.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};